import $ from 'jquery';

const cart = {
  className: 'cart-block--contents__expanded',
  close : () => {
    $('.' + cart.className)
      .removeClass(cart.className)
      .css('display', 'none');
  },
  init : (elementsHtmlTag) => {
    /* Close on blur */
    $(document).on('click', (e) => {
      let disallowedClasses = [
        'ui-dialog-titlebar-close',
      ];
      let regexDisallowedClasses = new RegExp('(^|\\s)(' +  disallowedClasses.join('|') + ')(\\s|$)');
      let allowedClasses = [
        cart.className,
        elementsHtmlTag.className,
        'ui-dialog',
        'ui-widget-overlay',
      ];
      let regexAllowedClasses = new RegExp('(^|\\s)(' +  allowedClasses.join('|') + ')(\\s|$)');

      if (
        (
          $(e.target).closest('.' +  disallowedClasses.join(', .')).length > 0
          || regexDisallowedClasses.test(e.target.className)
        )
        ||
        (
          $(e.target).closest('.' +  allowedClasses.join(', .')).length <= 0
          && !regexAllowedClasses.test(e.target.className)
        )
      ) {
        cart.close();
      }
    });
  }
};

export default cart;
